import {observer} from "mobx-react";
import {useServices} from "../../../../../react-hooks/use-services.hook";
import {OptInHighlightContentBox} from "./boxes/opt-in-heighlight-content/opt-in-heighlight-content.box";
import {OptInDialogHeaderBox} from "./boxes/opt-in-dialog-header.box";
import {OptInHeaderRowContainerBox} from "./boxes/opt-in-header-row-container/opt-in-header-row-container.box";
import {OptInHighlightLabelBox} from "./boxes/opt-in-highlight-label/opt-in-highlight-label.box";
import {OptInHighlightTextBox} from "./boxes/opt-in-heighlight-text/opt-in-heighlight-text.box";
import {OptInOuterFrameBox} from "./boxes/opt-in-outer-frame/opt-in-outer-frame.box";
import {OptInLogoBox} from "./boxes/opt-in-logo/opt-in-logo.box";


export const OptInDialogHeaderComponent: React.FC = observer(() => {
    const services = useServices();

    const renderIconJustInPortrait = () => {
        if (services.mediaQuery.landscape && services.mediaQuery.mAndBelow) {
            return null;
        }
        return <OptInLogoBox />
    }

    return (
        <OptInOuterFrameBox>
            <OptInDialogHeaderBox>
                {renderIconJustInPortrait()}
                <OptInHeaderRowContainerBox>
                    <OptInHighlightLabelBox>{services.translation.translate('JACKPOT_BET_WINNERS_TODAY')}</OptInHighlightLabelBox>
                    <OptInHighlightContentBox $isFirst>
                        <OptInHighlightTextBox>
                            {services.jackpotBet.jackpotsInfo.winnersCount}
                        </OptInHighlightTextBox>
                    </OptInHighlightContentBox>
                    <OptInHighlightLabelBox>{services.translation.translate('JACKPOT_BET_WON_TODAY')}</OptInHighlightLabelBox>
                    <OptInHighlightContentBox>
                        <OptInHighlightTextBox>
                            {services.currency.formatMoney(services.jackpotBet.jackpotsInfo.totalWinsToday)}
                        </OptInHighlightTextBox>
                    </OptInHighlightContentBox>
                </OptInHeaderRowContainerBox>
            </OptInDialogHeaderBox>
        </OptInOuterFrameBox>
    )
})